var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nuxt-link',{attrs:{"to":`/${_vm.prefix}/${_vm.item.id}`,"data-test":`${_vm.prefix}-title-${_vm.index}`}},[_vm._v(_vm._s(_vm.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }